document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".wrapper.ps-animated-job-listing").forEach((wrapper) => {
        const jobItems = wrapper.querySelectorAll(".job_title");

        if (jobItems.length === 0) {
            console.warn("No job items found inside a wrapper!");
            return;
        }

        // Get default background color from wrapper's data attribute
        const defaultBgColor = wrapper.dataset.defaultbgcolor || "#ffffff"; // Fallback if missing

        jobItems.forEach((item) => {
            item.setAttribute("tabindex","0");
            let bgColor = item.dataset.backgroundcolor || defaultBgColor; // Use job-specific or default color

            // Function to change wrapper background
            const changeWrapperBg = () => {
                wrapper.style.backgroundColor = bgColor;
            };

            // Function to reset wrapper background
            const resetWrapperBg = () => {
                wrapper.style.backgroundColor = defaultBgColor;
            };

            // Event listeners for hover and focus
            item.addEventListener("mouseenter", changeWrapperBg);
            item.addEventListener("mouseleave", resetWrapperBg);
            item.addEventListener("focusin", changeWrapperBg);  // Focus when tabbing
            item.addEventListener("focusout", resetWrapperBg); // Reset when losing focus
        });
    });
});
